import { ContractDto } from "@custom-types/contract"
import { Tooltip } from "@mui/material"
import { format } from "date-fns"
import { ReactElement } from "react"

type ContractTooltipProps = {
  contract: ContractDto | undefined
  children: ReactElement
}

const ContractTooltip = ({ contract, children }: ContractTooltipProps) => {
  if (!contract) return

  return (
    <Tooltip
      componentsProps={{ tooltip: { sx: { maxWidth: "none", fontSize: 14 } } }}
      placement="bottom-start"
      title={
        <ul>
          <li key="description">Description: {contract.description}</li>
          <li key="end-date">End date: {format(new Date(contract.end_date), "dd/MM/yyyy")}</li>
          <li key="product-families">
            Product families:
            <ol>
              {contract.product_families.map((productFamily) => (
                <li key={productFamily.family}>
                  {`${productFamily.product} (${productFamily.family})`}
                </li>
              ))}
            </ol>
          </li>
        </ul>
      }
    >
      {children}
    </Tooltip>
  )
}

export default ContractTooltip
